import Box from "@mui/material/Box";
import { useMemo } from "react";

import APAccordion from "../APAccordion";
import RestrictedAppScope from "../RestrictedAppScope";
import CopyGenericDossierUrlField from "./CopyGenericDossierUrlField";

export type MarketingUrlType =
  | "dossierVehicleReview"
  | "dossierVehicleSearchInput"
  | "dossierVehicleSearchResults"
  | "dossierVehicleComparison";

type CopyMarketingUrlProps = {
  type: MarketingUrlType;
  secondaryId?: string;
};

const CopyMarketingUrl = ({ type, secondaryId }: CopyMarketingUrlProps) => {
  const urlField = useMemo(() => {
    switch (type) {
      case "dossierVehicleReview":
        return (
          <CopyGenericDossierUrlField
            destination="dossierVehicleReview"
            secondaryId={secondaryId}
            statusRestriction="open"
            text="Copy the URL to share this review with anyone:"
            excludeSearchParams={["hideQuoteButton"]}
          />
        );
      case "dossierVehicleSearchInput":
        return (
          <CopyGenericDossierUrlField
            destination="dossierVehicleSearch"
            statusRestriction="open"
            text="Copy the URL to share this search with anyone:"
            excludeSearchParams={["hideQuoteButton"]}
          />
        );
      case "dossierVehicleSearchResults":
        return (
          <CopyGenericDossierUrlField
            destination="dossierVehicleSearchResults"
            statusRestriction="open"
            text="Copy the URL to share this search results with anyone:"
            excludeSearchParams={["hideQuoteButton"]}
          />
        );
      case "dossierVehicleComparison":
        return (
          <CopyGenericDossierUrlField
            destination="dossierVehicleComparison"
            statusRestriction="open"
            text="Copy the URL to share this comparison with anyone:"
            excludeSearchParams={["hideQuoteButton"]}
          />
        );
      default:
        return null;
    }
  }, [type]);

  return (
    <RestrictedAppScope scope="internal">
      <APAccordion title="Generic - Marketing">
        <Box my={2}>{urlField}</Box>
      </APAccordion>
    </RestrictedAppScope>
  );
};

export default CopyMarketingUrl;
